import React, {Fragment} from 'react';
import {
    BreakEditLandingPageFieldsToolTip,
    BreakLandingPageHeadlineMobileToolTip,
    BreakLandingPageHeadlineToolTip,
    BreakLandingPageIntroCopyToolTip,
    BreakLandingPageMobileIntroCopyToolTip,
} from 'components/break/tooltips/general-tool-tips';
import {LearnMoreHeadlineColorToolTip} from 'components/break/tooltips/breaks-color-section-tool-tips';
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';
import { isNewLayout} from 'utils/break-utils';
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";

export default {
    key: "breakLandingScreenSection",
    showField: (proxy) => {
        // console.log(`showSection`, proxy, proxy.currentResource )
        return (proxy.currentResource.sponsoredType === 'sponsored')
    },

    props: {
        headerKey: 'Landing Screen',

        getCustomSectionHeader: (brk, sectionIndex) => {
            // console.log(`landingPage`, content)
            if (!brk) {
                return "Landing Page"
            }

            return brk.overrideMapPageCopy ? "Landing Screen: On": "Landing Screen: Off";
      },

    },
    fields: [
        {
            conditionalSection: true,
            name: "overrideMapPageCopy",
            required: true,
            showField: (proxy) =>  (proxy.currentResource.sponsoredType === 'sponsored' ),
            props: {
                labelKey: 'Include landing screen?',
                // helpContent: <BreakEditLandingPageFieldsToolTip/>,
                // helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.editPageHeadline'}/></IntlProvider>,
            },

            fields: [
                {
                  type: 'radio',
                  name: "mapHeadlineType",
                  props: {
                    labelKey: 'editbreak.general.map_headline_type',
                    options: [
                      {
                        textKey: 'editbreak.general.map_headline_type.text',
                        value: 'TEXT'
                      },
                      {
                        textKey: 'editbreak.general.map_headline_type.image',
                        value: 'IMAGE'
                      }
                    ]
                  }
                },
                {
                    type: "contenteditable",
                    name: "mapHeadline",
                    required: true,
                    linkedField: (formProxy) => ["title"],
                    showField: (proxy) => (proxy.currentResource.mapHeadlineType === 'TEXT'),
                    props: {
                        labelKey: "editbreak.general.mapPage.headline",
                        helpContent: <BreakLandingPageHeadlineToolTip/>,
                        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.mapPage.headline'}/></IntlProvider>
                    }
                },
                {
                  type: "image",
                  name: 'mapHeadlineImageId',
                  idFor: 'mapHeadlineImage',
                  showField: (proxy) => (proxy.currentResource.mapHeadlineType === 'IMAGE' && !isNewLayout(proxy.currentResource)),
                  props: {
                    labelKey: 'editbreak.general.mapPage.headline_image',
                    imageType: 'mapHeadlineImage'
                  }
                },
                {
                    type: "image",
                    name: 'mapHeadlineImageId',
                    idFor: 'mapHeadlineImage',
                    showField: (proxy) => (proxy.currentResource.mapHeadlineType === 'IMAGE' && isNewLayout(proxy.currentResource)),
                    props: {
                      labelKey: 'editbreak.general.mapPage.headline_image',
                      imageType: 'mapHeadlineImage2020'
                    }
                  },
                  {
                    type: "contenteditable",
                    name: "mapDescription",
                    required: false,
                    showField: (proxy) => {
                        // console.log(`proxy`, proxy.currentResource)
                        return proxy.currentResource.overrideMapPageCopy
                    },
                    props: {
                        labelKey: "editbreak.general.mapPage.description",
                        helpContent: <BreakLandingPageIntroCopyToolTip/>,
                        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.mapPage.description'}/></IntlProvider>
                    }
                },
                {
                    conditionalSection: true,
                    name: 'hasLearnMore',

                    props: {
                        labelKey: 'editbreak.general.learnMoreSectionHeadline',
                          helpContent: <LearnMoreHeadlineColorToolTip/>,
                          helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.learnMoreSectionHeadline'}/></IntlProvider>,
                    },

                    fields: [
                        {
                            type: 'text',
                            name: 'learnMoreHeadline',
                            required: true,
                            props: {
                                labelKey: 'editbreak.general.learnMoreHeadline'

                            }
                        },
                        {
                            type: 'textarea',
                            name: 'learnMoreDesc',
                            required: true,
                            props: {
                                labelKey: 'editbreak.general.learnMoreDesc'
                            }
                        },
                        {
                            type: 'text',
                            name: 'learnMoreButtonText',
                            required: true,
                            props: {
                                labelKey: 'editbreak.general.learnMoreButtonCopy'
                            }
                        },
                        {
                            type: 'image',
                            name: 'learnMoreImageId',
                            idFor: 'learnMoreImage',
                            props: {
                                labelKey: 'editbreak.general.learnMoreImageId',
                                imageType: 'clientLogo'
                            }
                        }
                    ]
                }
            ]
        },  // end override map copy
        {
            conditionalSection: true,
            name: "overrideMobileMapPageCopy",
            required: true,
            showField: (proxy) => {
                console.log(`proxy`, proxy.currentResource)
                return proxy.currentResource.overrideMapPageCopy
            },

            // showField: (proxy) =>  (proxy.currentResource.sponsoredType === 'sponsored' || (proxy.currentResource.steps && proxy.currentResource.steps.length > 1)),
            props: {
                labelKey: 'editbreak.general.editPageMobileHeadline'
            },

            fields: [
                {
                  type: 'radio',
                  name: "mobileMapHeadlineType",
                  props: {
                    labelKey: 'editbreak.general.mobile_map_headline_type',
                    options: [
                      {
                        textKey: 'editbreak.general.mobile_map_headline_type.text',
                        value: 'TEXT'
                      },
                      {
                        textKey: 'editbreak.general.mobile_map_headline_type.image',
                        value: 'IMAGE'
                      }
                    ]
                  }
                },
                {
                    type: "contenteditable",
                    name: "mapHeadlineMobile",
                    required: true,
                    linkedField: (formProxy) => ["title"],
                    showField: (proxy) => (proxy.currentResource.mobileMapHeadlineType === 'TEXT'),
                    props: {
                        labelKey: "editbreak.general.mapPage.mobileHeadline",
                        helpContent: <BreakLandingPageHeadlineMobileToolTip/>,
                        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.mapPage.mobileHeadline'}/></IntlProvider>
                    }
                },
                {
                  type: "image",
                  name: 'mobileMapHeadlineImageId',
                  idFor: 'mobileMapHeadlineImage',
                  showField: (proxy) => (proxy.currentResource.mobileMapHeadlineType === 'IMAGE'),
                  props: {
                    labelKey: 'editbreak.general.mapPage.mobile_headline_image',
                    imageType: 'custom'
                  }
                },
                {
                    type: "contenteditable",
                    name: "mapDescriptionMobile",
                    required: true,
                    props: {
                        labelKey: "editbreak.general.mapPage.mobileDescription",
                        helpContent: <BreakLandingPageMobileIntroCopyToolTip/>,
                        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.mapPage.mobileDescription'}/></IntlProvider>,
                        validationRules: [
                            {
                                type: 'HTMLHasTextContent'
                            }
                        ]
                    }
                }
            ]
        },  // end override mobile map copy
        {
            type: 'image',
            name: 'logoImageId',
            showField: (proxy) => (proxy.currentResource.sponsoredType === 'sponsored' && isNewLayout(proxy.currentResource)),
            idFor: 'logoImage',
            props: {
                // fieldLabel: 'Client Logo (upper right)', // using fieldLable will break platform bs
                labelKey: 'editbreak.design.logoImage',
              imageType: 'logoImage'
            }
          },
          {
            type: 'image',
            name: 'backgroundImageId',
            idFor: 'backgroundImage',
            showField: (proxy) =>  isNewLayout(proxy.currentResource),
            props: {
                labelKey: 'Landing Background Image (1920px wide)',
                imageType: "custom",
            }
        },
        {
            type: 'image',
            name: 'mobileBackgroundImageId',
            idFor: 'mobileBackgroundImage',
            showField: (proxy) =>  isNewLayout(proxy.currentResource),
            props: {
                labelKey: 'Landing Background Image - mobile (900px wide)',
                imageType: "custom",
            }
        },
        {
            type: 'yesnoradio',
            name: 'hasBackgroundOverlay',
            required: true,
            props: {
              labelKey: 'editbreak.design.landingBackgroundOverlay'
            }
        },    
        {
            type: 'textarea',
            name: 'landingPageFooterHtml',
            props: {
                labelKey: 'editbreak.design.landingPageFooterHtml'
            }
        }

    ]
};



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksLandingScreenSection.js